// extracted by mini-css-extract-plugin
export default {"mainDisplay":"main_mainDisplay__eH4f2","mainDisplayWrapper":"main_mainDisplayWrapper__faLLP","championIllustration":"main_championIllustration__0ildi"};